module.exports = __webpack_public_path__ + "img/djyl_img.db6ccef6.jpg";